module.exports = __webpack_public_path__ + "img/semi-circle.d8da33ac.png";